export const ResetFilter = (filters, filterKey) => {
    return filters.map(filter => {
        if (filter.key === filterKey) {
            filter.filters.forEach(nestedFilter => {
                if (nestedFilter.viewType === 'multi_select') {
                    nestedFilter.choices.forEach(choice => {
                        choice.active = false;
                    });
                }
                if (['open_input_range_list', 'range_list'].includes(nestedFilter.viewType)) {
                    nestedFilter.selectedMinValue = '';
                    nestedFilter.selectedMaxValue = '';
                }
            });

            if (filter.viewType === 'multi_select') {
                filter.choices.forEach(choice => {
                    choice.active = false;
                });
            }
            if (['open_input_range_list', 'range_list'].includes(filter.viewType)) {
                filter.selectedMinValue = '';
                filter.selectedMaxValue = '';
            }
        }
        return filter;
    });
};
